import { Box, ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';

import {
  FLEXIBLE_PROPERTIES_VIEW_MODE,
  type FlexiblePropertiesViewMode,
} from '../../../constants/FlexiblePropertiesConstants';

type Props = {
  viewMode: FlexiblePropertiesViewMode;
  onViewModeChange: (viewMode: FlexiblePropertiesViewMode) => void;
  isLoading?: boolean;
};

export const ViewMode = ({ viewMode, onViewModeChange, isLoading = false }: Props) => {
  const handleViewModeChange = (value: string | Array<string>) => {
    const selectedViewMode = Array.isArray(value) ? value[0] : value;
    onViewModeChange(selectedViewMode as FlexiblePropertiesViewMode);
  };

  return (
    <Box
      css={{
        flex: { base: '1', xl: '0 0 auto' },
        marginInlineStart: { xl: 'auto' },
      }}
    >
      <ToggleButtonGroup
        id="ft-toolbar-view-mode"
        aria-label="Filter property list by view"
        size="sm"
        fluid
        value={viewMode}
        onValueChange={handleViewModeChange}
        disabled={isLoading}
        css={{ width: { base: '100%', xl: '272px' } }}
        data-testid="FlexiblePropertiesPage-Filters-ViewMode"
      >
        <ToggleButton value={FLEXIBLE_PROPERTIES_VIEW_MODE.PROPERTIES}>Properties</ToggleButton>
        <ToggleButton value={FLEXIBLE_PROPERTIES_VIEW_MODE.UNITS}>Units</ToggleButton>
        <ToggleButton value={FLEXIBLE_PROPERTIES_VIEW_MODE.BOTH}>Both</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
